import { TableFilterState } from '@ibsys/kit';
import type { SearchKnowledgeFilters } from '@/entities/search';
import { tableFilters2Query } from '@/shared/lib';

/** Builds filters for knowledge entity (isDeleted, type, knowledgeSetId, knowledgeSetContext, spec: filters by entityType) */
export const buildKnowledgeFilters = (filters: TableFilterState): SearchKnowledgeFilters | undefined => {
  const searchFilters = tableFilters2Query(filters);
  return Object.keys(searchFilters).length > 0 ? (searchFilters as SearchKnowledgeFilters) : undefined;
};
